import axios from "axios";

export default function PanierLengVisiteur(IDVisiteur:any,Type:any) {
        const urlPanier= `${process.env.REACT_APP_PHP_APP_URL}/panier/visiteur/${IDVisiteur}/${Type}`;
    const GetLenPanier=()=>{
        return (axios.get(urlPanier));
    }
    return {
        GetLenPanier
    }
}